/**
 * Single-tooth toggle button. Visual is a stylized tooth shape (crown + roots)
 * inside a clickable square. Active = filled in tone color, inactive = outline.
 */
export default function ToothButton({ num, active, onClick, disabled, tone = 'blue' }) {
  const T = TONE[tone] || TONE.blue
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={`Tooth ${num}`}
      aria-pressed={active}
      className={`group relative flex flex-col items-center justify-end w-[30px] h-[36px] rounded-md transition-all select-none ${
        disabled ? 'cursor-default' : 'cursor-pointer hover:-translate-y-[1px]'
      } ${
        active
          ? `${T.activeBg} ${T.activeRing} ring-1`
          : 'bg-white ring-1 ring-slate-200 hover:ring-slate-300'
      }`}
    >
      <ToothGlyph active={active} tone={tone} />
      <span
        className={`absolute inset-x-0 top-0.5 text-center text-[11px] font-mono leading-none ${
          active ? T.activeText : 'text-slate-400'
        }`}
      >
        {num}
      </span>
    </button>
  )
}

const TONE = {
  blue:   { activeBg: 'bg-blue-50',   activeRing: 'ring-blue-400',   activeText: 'text-blue-700',   activeFill: '#2563eb', inactiveFill: '#cbd5e1' },
  violet: { activeBg: 'bg-violet-50', activeRing: 'ring-violet-400', activeText: 'text-violet-700', activeFill: '#7c3aed', inactiveFill: '#cbd5e1' },
}

function ToothGlyph({ active, tone }) {
  const T = TONE[tone] || TONE.blue
  const fill = active ? T.activeFill : T.inactiveFill
  // Simple molar-ish silhouette: a rounded crown with two roots.
  return (
    <svg width="16" height="20" viewBox="0 0 16 20" aria-hidden="true" className="mb-0.5">
      <path
        d="M3 3.5C3 2.1 4.2 1.2 5.7 1.2c1 0 1.7.4 2.3.4s1.3-.4 2.3-.4c1.5 0 2.7.9 2.7 2.3 0 1.5-.5 3-.7 4.4-.1.9-.1 1.6-.4 3-.2 1-.5 2.2-1 2.9-.4.6-.9.7-1.3.5-.4-.2-.5-.8-.6-1.5-.2-1.2-.4-2-.7-2.2-.2-.2-.5-.2-.7 0-.3.2-.5 1-.7 2.2-.1.7-.2 1.3-.6 1.5-.4.2-.9.1-1.3-.5-.5-.7-.8-1.9-1-2.9-.3-1.4-.3-2.1-.4-3C3.5 6.5 3 5 3 3.5Z"
        fill={fill}
        opacity={active ? 1 : 0.55}
      />
    </svg>
  )
}
